import axios, { 
   AxiosRequestConfig, AxiosResponse } from 'axios';

const BASE_URL = "https://api.rakeshbansalventures.com/api";
// export const BASE_URL = "http://localhost:3019/api/";
export const FRONTEND_URL = "https://checkout.rakeshbansalventures.com";

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: true,
});

function getToken() {
  return localStorage.getItem('rkb_token');
}

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    (config.headers as any) = config.headers || {};
    (config.headers as any).Authorization = `Bearer ${token}`;
  }

  return config;
});

export async function get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
  try {
    const res: AxiosResponse<T> = await api.get(url, config);
    return res.data;
  } catch (err) {
    // handleError(err);
    throw err;
  }
}

export async function post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
  try {
    const res: AxiosResponse<T> = await api.post(url, data, config);
    return res.data;
  } catch (err) {
    // handleError(err);
    throw err;
  }
}



export default api;
